import React from "react";

import { Layout } from "../../components/layout";
import { SEO } from "../../components/meta";
import { ContentObject } from "../../components/content";

import Heading from "./case-studies-heading";
import Items from "./case-studies-items";
import Estimate from "./case-studies-estimate";

const CaseStudies = () => (
  <>
    <SEO
      title={ContentObject.CaseStudies.meta.title}
      description={ContentObject.CaseStudies.meta.description}
    />

    <Layout header={{ position: "absolute" }} footer={{ size: "compact" }}>
      <section data-csweb="case-studies">
        <Heading />
        <Items />
        <Estimate />
      </section>
    </Layout>
  </>
);

export default CaseStudies;
